<template>
  <div class="page">
    <!-- Попап для демонстрации/отправки отзыва и фон вокруг него -->
    <div class="screen-veil" :class="{ 'screen-veil_photo': popupContentData.type === 'photo' }" v-if="isFeedbackPopupShown" @click="closePopupByClickAround">
      <div class="popup" :class="{ popup_photo: popupContentData.type === 'photo' }">
        <!-- кнопка закрытия -->
        <div class="popup__close-button" :class="{ 'popup__photo-close-button': popupContentData.type === 'photo' }" @click="closePopup"></div>
        <!-- Контент отзыва -->
        <div class="popup__content" :class="{ popup__content_photo: popupContentData.type === 'photo' }" v-if="popupContentData.type !== 'feedback-form'">
          <!-- текстовый отзыв -->
          <div class="popup__text-content" v-if="popupContentData.type === 'text'">
            {{ popupContentData?.textToPopup }}
          </div>
          <!-- отзыв — фотография -->
          <div class="popup__photo-content" v-if="popupContentData.type === 'photo'">
            <div class="popup__photo-feedback">
              <img class="popup__photo-feedback-pic" :src="popupContentData?.photoToPopup?.url" :alt="popupContentData?.photoToPopup?.alt" />
            </div>
          </div>
          <!-- отзыв — видео -->
          <!-- ...код -->
          <div class="popup__video-content" v-if="popupContentData.type === 'video'">
            <div class="popup__video" style="margin: 0 auto; text-align: center" v-html="popupContentData.videoLink"></div>
          </div>
          <!-- информация о клиенте -->
          <div class="popup__client-info-container">
            <!--            &lt;!&ndash; аватар клиента &ndash;&gt;-->
            <!--            <div class="popup__client-avatar">-->
            <!--              <img class="popup__client-avatar-pic" :src="popupContentData?.avatarOfClient?.url"-->
            <!--                   :alt="popupContentData?.avatarOfClient?.alt">-->
            <!--            </div>-->
            <!-- текстовая информация о клиенте -->
            <div class="popup__client-text-info">
              <!-- имя клиента -->
              <p class="popup__client-name">{{ popupContentData?.nameOfClient }}</p>
              <!-- описание клиента -->
              <p class="popup__client-description">{{ popupContentData?.descriptionOfClient }}</p>
            </div>
          </div>
        </div>
        <!-- Форма отправки отзыва -->
        <div class="feedback-send-form" v-if="popupContentData.type === 'feedback-form'">
          <div class="feedback-send-form__form-wrapper" v-show="!wasFeedbackSent">
            <!-- заголовок -->
            <h2 class="feedback-send-form__title">Оставить отзыв</h2>
            <p class="feedback-send-form__description-text">
              Если вы хотите получить обратную связь от руководителя службы качества, пожалуйста, укажите ФИО, контактный номер телефона и суть обращения.
            </p>
            <!-- форма -->
            <form class="feedback-send-form__form-container" action="#">
              <!-- текст отзыва -->
              <div class="feedback-send-form__form-component">
                <h5 class="feedback-send-form__component-title">Ваш отзыв</h5>
                <textarea
                  class="feedback-send-form__feedback-text-field"
                  name="feedback-text-field"
                  id=""
                  cols="30"
                  rows="10"
                  placeholder="Введите текст отзыва"
                  v-model="feedbackDataToSend.feedbackText"
                ></textarea>
              </div>
              <!-- ввод данных о клиенте -->
              <div class="feedback-send-form__form-component">
                <h5 class="feedback-send-form__component-title">Представьтесь</h5>
                <div class="feedback-send-form__client-info-fields-container">
                  <!-- поле имени -->
                  <div class="feedback-send-form__client-info-field">
                    <input class="feedback-send-form__field feedback-send-form__name-field" type="text" placeholder="" v-model="feedbackDataToSend.nameOfClient" />
                    <label class="feedback-send-form__field-label" :class="{ 'feedback-send-form__field-label_unempty-field': !!feedbackDataToSend.nameOfClient.length }">Имя</label>
                  </div>
                  <!-- поле телефона -->
                  <div class="feedback-send-form__client-info-field">
                    <input class="feedback-send-form__field feedback-send-form__telephone-field" type="text" placeholder="" v-model="feedbackDataToSend.telephoneOfClient" />
                    <label class="feedback-send-form__field-label" :class="{ 'feedback-send-form__field-label_unempty-field': !!feedbackDataToSend.telephoneOfClient.length }">Телефон</label>
                  </div>
                </div>
              </div>
              <!-- согласие на обработку персональных данных -->
              <div class="feedback-send-form__form-component">
                <label class="feedback-send-form__checkbox-content">
                  <div class="feedback-send-form__checkbox-icon" :class="{ 'feedback-send-form__checkbox-icon_agree': feedbackDataToSend.isAgreeToWorkWithData }"></div>
                  <input type="checkbox" class="feedback-send-form__checkbox" v-model="feedbackDataToSend.isAgreeToWorkWithData" />
                  <p class="feedback-send-form__text-content">
                    Я даю <a href="https://lahtaclinic.ru/agreement" target="_blank" class="feedback-send-form__personal-data-link">согласие</a> на обработку персональных данных, ознакомлен(а) с
                    <a class="feedback-send-form__personal-data-link" href="https://lahtaclinic.ru/licenses-and-documents/politika-obrabotki-i-zashity-personalnyh-dannyh/" target="_blank"
                      >Политикой конфиденциальности</a
                    >
                  </p>
                </label>
              </div>
              <!-- кнопка отправки формы -->
              <div class="feedback-send-form__form-component">
                <div class="feedback-send-form__submit-button-container">
                  <div class="feedback-send-form__submit-button" :class="{ 'feedback-send-form__submit-button_disabled': !feedbackFormValidation }" @click="sendFeedback">Отправить</div>
                  <!--
                                        для disabled
                                       linear-gradient(270deg, rgba(163,163,163,1) 0%, rgba(32,143,221,1) 100%); - фон
                                       #cdcdcd - текст
                                    -->
                </div>
              </div>
            </form>
          </div>
          <!-- Окно, выводящееся при успехе -->
          <div class="feedback-send-form__success-message-wrapper" v-show="wasFeedbackSent">
            <div class="feedback-send-form__success-message-pic"></div>
            <div class="feedback-send-form__success-message-title like-h2">Спасибо</div>
            <p class="feedback-send-form__success-message-text">{{ callRequestWasSent ? 'Cпасибо за заявку! Менеджер свяжется с вами в ближайшее время' : 'Нам важно ваше мнение' }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- Верхний попап "Перезвоните мне" -->
    <ApplicationForm
      v-show="isShownPopup"
      @hidePopup="hidePopup"
      :formContent="currentFormContent"
      site="Oncall"
      :hideComment="isInactivityPopup"
      :buttonText="isInactivityPopup ? 'Позвоните мне' : 'Оставить заявку'"
    />
    <ApplicationVideo v-if="isShownPopupVideo" @hidePopup="hidePopup" />
    <!-- Хедер -->
    <header class="page__header">
      <!-- Хедер -->
      <div class="header">
        <!-- Хедер - контент -->
        <div class="wrapper">
          <div class="header__content-container">
            <!-- Левая сторона хедера -->
            <div class="header__left-side">
              <!-- логотип фирмы -->
              <div class="header__logo">
                <div class="header__logo-pic">
                  <div class="header__logo-pic-img">
                    <svg xmlns="http://www.w3.org/2000/svg" role="img" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="27" viewBox="0 0 70 80" fill="none">
                      <title>вызов врача на дом в приморском районе</title>
                      <rect width="70" height="80" fill="url(#pattern1)" />
                      <defs>
                        <pattern id="pattern1" patternContentUnits="objectBoundingBox" width="1" height="1">
                          <use xlink:href="#image0_310_3416" transform="scale(0.0113343 0.010101)" />
                        </pattern>
                        <image
                          id="image0_310_3416"
                          width="396"
                          height="99"
                          xlink:href="data:image/png;base64,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"
                        />
                      </defs>
                    </svg>
                  </div>
                </div>
                <div class="header__logo-text">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="143" height="16" viewBox="0 0 143 16" fill="none">
                    <rect x="0.5" width="142" height="16" fill="url(#pattern0)" />
                    <defs>
                      <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                        <use xlink:href="#image0_310_3409" transform="translate(-0.359155 -2) scale(0.00343221 0.030303)" />
                      </pattern>
                      <image
                        id="image0_310_3409"
                        width="396"
                        height="99"
                        xlink:href="data:image/png;base64,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"
                      />
                    </defs>
                  </svg>
                </div>
              </div>
              <div class="_header__dropdown">
                <button class="_header__dropdown-toggler" type="button">
                  <div class="other-site-link__place-sign-pic"></div>
                  <span>Lahta clinic</span>
                  <svg class="_header__dropdown-toggler-icon" width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </button>
                <div class="_header__dropdown-menu">
                  <!-- ссылка на сайт - Лахта Клиник -->
                  <a class="header__other-site-link" href="#" @click="openLink('https://lahtaclinic.ru')">
                    <div class="other-site-link">
                      <div class="other-site-link__place-sign-pic"></div>
                      <div class="other-site-link__text-content">
                        <h5 class="other-site-link__title">Lahta clinic</h5>
                        <p class="other-site-link__description">Многопрофильная клиника</p>
                      </div>
                    </div>
                  </a>
                  <!-- ссылка на сайт - Лахта Джуниор -->
                  <a class="header__other-site-link" href="#" @click="openLink('https://lahtajunior.ru')">
                    <div class="other-site-link">
                      <div class="other-site-link__place-sign-pic"></div>
                      <div class="other-site-link__text-content">
                        <h5 class="other-site-link__title">Lahta Junior</h5>
                        <p class="other-site-link__description">Детская клиника</p>
                      </div>
                    </div>
                  </a>
                  <a class="header__other-site-link" href="#" @click="openLink('https://lahtaclinic.ru/clinic/lahta_klinika_na_parfenovskoi/')">
                    <div class="other-site-link">
                      <div class="other-site-link__place-sign-pic"></div>
                      <div class="other-site-link__text-content">
                        <h5 class="other-site-link__title">Lahta Clinic на Парфеновской</h5>
                        <p class="other-site-link__description">Многопрофильная клиника</p>
                      </div>
                    </div>
                  </a>
                  <a class="header__other-site-link" href="#" @click="openLink('https://lahtaclinic.ru/mentalnoe-zdorove/')">
                    <div class="other-site-link">
                      <div class="other-site-link__place-sign-pic"></div>
                      <div class="other-site-link__text-content">
                        <h5 class="other-site-link__title">Lahta Clinic центр ментального здоровья</h5>
                        <p class="other-site-link__description">Клиника доказательной психотерапии</p>
                      </div>
                    </div>
                  </a>
                  <!-- ссылка на сайт - Лахта Вумэн -->
                  <a class="header__other-site-link" href="#" @click="openLink('https://lahtawoman.ru')">
                    <div class="other-site-link">
                      <div class="other-site-link__place-sign-pic"></div>
                      <div class="other-site-link__text-content">
                        <h5 class="other-site-link__title">Lahta woman</h5>
                        <p class="other-site-link__description">Женская клиника</p>
                      </div>
                    </div>
                  </a>
                  <!-- ссылка на сайт - LAHTA DENTAL -->
                  <a class="header__other-site-link" href="#" @click="openLink('http://lahtadental.ru/')">
                    <div class="other-site-link">
                      <div class="other-site-link__place-sign-pic"></div>
                      <div class="other-site-link__text-content">
                        <h5 class="other-site-link__title">Lahta Dental</h5>
                        <p class="other-site-link__description">Стоматология</p>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <!-- Правая сторона хедера -->
            <div class="header__right-side">
              <!-- кнопки на мобильном -->
              <div class="header__mobile-buttons">
                <!-- кнопка "перезвоните мне" - мобильный -->
                <a class="call-me-link" href="tel:88126402868">
                  <div class="header__call-me-button-pic"></div>
                </a>
                <!-- кнопка "меню" - мобильный -->
                <div class="header__dropdown-menu-button-pic" @click="showDropDownMenu"></div>
              </div>
              <!-- телефон - десктоп -->
              <div class="header__tel"><a href="tel:+78126402868" style="color: #425f86">+7 812 640-28-68</a></div>
            </div>
          </div>
        </div>
        <!-- Выпадающее меню -->
        <div class="dropdown-menu" v-show="isDropDownMenuShown">
          <div class="dropdown-menu__line-background"></div>
          <div class="wrapper">
            <div class="header__logo">
              <div class="header__logo-pic">
                <!-- <img class="header__logo-pic-img" :src="logoWay.url" :alt="logoWay.alt"> -->
                <div class="header__logo-pic-img">
                  <svg xmlns="http://www.w3.org/2000/svg" role="img" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="27" viewBox="0 0 70 80" fill="none">
                    <title>вызов врача на дом в приморском районе</title>
                    <rect width="70" height="80" fill="url(#pattern1)" />
                    <defs>
                      <pattern id="pattern1" patternContentUnits="objectBoundingBox" width="1" height="1">
                        <use xlink:href="#image0_310_3416" transform="scale(0.0113343 0.010101)" />
                      </pattern>
                      <image
                        id="image0_310_3416"
                        width="396"
                        height="99"
                        xlink:href="data:image/png;base64,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"
                      />
                    </defs>
                  </svg>
                </div>
              </div>
              <div class="header__logo-text">
                <!-- <img class="header__logo-text-img" :src="logoTextWay.url" :alt="logoTextWay.alt"> -->
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="143" height="16" viewBox="0 0 143 16" fill="none">
                  <rect x="0.5" width="142" height="16" fill="url(#pattern0)" />
                  <defs>
                    <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                      <use xlink:href="#image0_310_3409" transform="translate(-0.359155 -2) scale(0.00343221 0.030303)" />
                    </pattern>
                    <image
                      id="image0_310_3409"
                      width="396"
                      height="99"
                      xlink:href="data:image/png;base64,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"
                    />
                  </defs>
                </svg>
              </div>
            </div>
            <!-- кнопка "закрыть" -->
            <div class="dropdown-menu__close-button-container">
              <div class="dropdown-menu__close-button" @click="hideDropDownMenu"></div>
            </div>
          </div>
          <div class="dropdown-menu__local-wrapper">
            <!-- навигационное меню -->
            <div class="dropdown-menu__nav-menu">
              <ul class="nav-menu">
                <li class="nav-menu__item">
                  <a class="nav-menu__item-link" href="#when-call-a-doctor_hack" @click="hideDropDownMenu">Симптомы</a>
                </li>
                <li class="nav-menu__item">
                  <a class="nav-menu__item-link" href="#oncall-service-team" @click="hideDropDownMenu">Врачи</a>
                </li>
                <li class="nav-menu__item">
                  <a class="nav-menu__item-link" href="#what-to-do-at-home" @click="hideDropDownMenu">Услуги</a>
                </li>
                <li class="nav-menu__item">
                  <a class="nav-menu__item-link" href="#patients-feedbacks" @click="hideDropDownMenu">Отзывы</a>
                </li>
                <li class="nav-menu__item">
                  <a class="nav-menu__item-link" href="#work-zone-map" @click="hideDropDownMenu">Цены</a>
                </li>
                <li class="nav-menu__item">
                  <a class="nav-menu__item-link" href="#our-answers" @click="hideDropDownMenu">FAQ</a>
                </li>
              </ul>
            </div>
          </div>
          <!-- ссылки на сайты -->
          <div class="dropdown-menu__other-site-link-container">
            <!-- ссылка на сайт - Лахта Клиник -->
            <a class="dropdown-menu__other-site-link" href="#" @click="openLink('https://lahtaclinic.ru')">
              <div class="other-site-link">
                <div class="other-site-link__place-sign-pic"></div>
                <div class="other-site-link__text-content">
                  <h5 class="other-site-link__title">Lahta clinic</h5>
                  <p class="other-site-link__description">Многопрофильная клиника</p>
                </div>
              </div>
            </a>
            <!-- ссылка на сайт - Лахта Джуниор -->
            <a class="dropdown-menu__other-site-link" href="#" @click="openLink('https://lahtajunior.ru')">
              <div class="other-site-link">
                <div class="other-site-link__place-sign-pic"></div>
                <div class="other-site-link__text-content">
                  <h5 class="other-site-link__title">Lahta Junior</h5>
                  <p class="other-site-link__description">Детская клиника</p>
                </div>
              </div>
            </a>
            <!-- ссылка на сайт - Лахта Вумэн -->
            <a class="dropdown-menu__other-site-link" href="#" @click="openLink('https://lahtawoman.ru')">
              <div class="other-site-link">
                <div class="other-site-link__place-sign-pic"></div>
                <div class="other-site-link__text-content">
                  <h5 class="other-site-link__title">Lahta woman</h5>
                  <p class="other-site-link__description">Женская клиника</p>
                </div>
              </div>
            </a>
            <!-- ссылка на сайт - Lahta Dental -->
            <a class="dropdown-menu__other-site-link" href="#" @click="openLink('http://lahtadental.ru/')">
              <div class="other-site-link">
                <div class="other-site-link__place-sign-pic"></div>
                <div class="other-site-link__text-content">
                  <h5 class="other-site-link__title">Lahta Dental</h5>
                  <p class="other-site-link__description">Стоматология</p>
                </div>
              </div>
            </a>
          </div>
          <!-- телефон -->
          <div class="dropdown-menu__tel"><a href="tel:+78126402868" style="color: #425f86">+7 812 640-28-68</a></div>
          <!-- кнопка "перезвоните мне" -->
          <div class="dropdown-menu__call-me-button-container">
            <div class="dropdown-menu__local-wrapper">
              <div class="call-me-button">
                <a class="call-me-link">
                  <!-- href="#submit-application" -->
                  <div class="call-me-button__button" @click="showPopup">Перезвоните мне</div>
                </a>
              </div>
            </div>
          </div>

          <!-- кнопка "вызвать врача" -->
          <div class="dropdown-menu__call-doctor-button">
            <div class="call-doctor-button">
              <div class="call-doctor-button__button"><a class="call-doctor-link" href="#" @click="openLink('https://oncall.lahtaclinic.ru/app')">Вызвать врача</a></div>
            </div>
          </div>
        </div>
      </div>
    </header>
    <!-- Центральные функции -->
    <div class="central-functions none" id="central-functions">
      <div class="wrapper">
        <div class="central-functions__container">
          <!-- левая часть -->
          <div class="central-functions__left-part">
            <!-- лого -->
            <a href="#">
              <div class="central-functions__logo"></div>
            </a>
            <!-- навигационное меню -->
            <div class="central-functions__nav-menu">
              <ul class="nav-menu">
                <li class="nav-menu__item">
                  <a class="nav-menu__item-link" href="#when-call-a-doctor">Симптомы</a>
                </li>
                <li class="nav-menu__item">
                  <a class="nav-menu__item-link" href="#oncall-service-team">Врачи</a>
                </li>
                <li class="nav-menu__item">
                  <a class="nav-menu__item-link" href="#what-to-do-at-home">Услуги</a>
                </li>
                <li class="nav-menu__item">
                  <a class="nav-menu__item-link" href="#patients-feedbacks">Отзывы</a>
                </li>
                <li class="nav-menu__item">
                  <a class="nav-menu__item-link" href="#work-zone-map">Цены</a>
                </li>
                <li class="nav-menu__item">
                  <a class="nav-menu__item-link" href="#our-answers">FAQ</a>
                </li>
              </ul>
            </div>
          </div>
          <!-- правая часть -->
          <div class="central-functions__right-part">
            <!-- телефон -->
            <div class="central-functions__tel"><a href="tel:+78126402868" style="color: #425f86">+7 812 640-28-68</a></div>
            <!-- кнопка "перезвоните мне" -->
            <div class="central-functions__call-me-button">
              <div class="call-me-button">
                <a class="call-me-link">
                  <!-- href="#submit-application" -->
                  <div class="call-me-button__button" @click="showPopup">Перезвоните мне</div>
                </a>
              </div>
            </div>
            <!-- кнопка "вызвать врача" -->
            <div class="central-functions__call-doctor-button">
              <div class="call-doctor-button">
                <div class="call-doctor-link" @click="showPopup">
                  <div class="call-doctor-button__button">Вызвать врача</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Главный блок -->
    <main class="page__main">
      <!-- Верхняя полоса с функциями -->
      <div class="wrapper">
        <div class="top-functions">
          <!-- верхнее навигационное меню -->
          <div class="top-functions__nav-menu">
            <ul class="nav-menu">
              <li class="nav-menu__item">
                <a class="nav-menu__item-link" href="#when-call-a-doctor">Симптомы</a>
              </li>
              <li class="nav-menu__item">
                <a class="nav-menu__item-link" href="#oncall-service-team">Врачи</a>
              </li>
              <li class="nav-menu__item">
                <a class="nav-menu__item-link" href="#what-to-do-at-home">Услуги</a>
              </li>
              <li class="nav-menu__item">
                <a class="nav-menu__item-link" href="#patients-feedbacks">Отзывы</a>
              </li>
              <li class="nav-menu__item">
                <a class="nav-menu__item-link" href="#work-zone-map">Цены</a>
              </li>
              <li class="nav-menu__item">
                <a class="nav-menu__item-link" href="#our-answers">FAQ</a>
              </li>
            </ul>
          </div>
          <!-- "кнопка "перезвоните мне" -->
          <div class="top-functions__call-me-button-container">
            <div class="call-me-button">
              <a class="call-me-link">
                <!-- href="#submit-application" -->
                <div class="call-me-button__button" @click="showPopup">Перезвоните мне</div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- Приветственный блок -->
      <div class="greeting-block">
        <!-- контент над фоном -->
        <div class="wrapper">
          <div class="greeting-block__top-content">
            <!-- логотип фирмы -->
            <div class="greeting-block__logo">
              <!-- лого -->
              <!-- <div class="greeting-block__logo-pic"></div> -->
              <!-- lahta clinic - текст -->
              <!-- <div class="greeting-block__firm-branch-name"></div> -->

              <!-- svg-код логотипа -->
            </div>
            <!-- текст -->
            <div class="greeting-block__text">
              <h1 class="greeting-block__title">
                Педиатр на дом
                <span class="greeting-block__title-key">в Сосновом Бору</span>
              </h1>
              <p class="greeting-block__content">Выездная служба педиатров Lahta Clinic из Санкт-Петербурга</p>
            </div>
            <!-- кнопка вызова врача -->
            <div class="greeting-block__call-doctor-button-container">
              <div class="greeting-block__call-doctor-button" @click="showPopup">Вызвать врача</div>
            </div>
          </div>
        </div>
        <!-- фон -->
        <div class="greeting-block__background"></div>
        <!-- аргументы в пользу -->
        <div class="greeting-block__arguments-wrapper wrapper">
          <div class="greeting-block__useful-arguments"> 
            <div class="useful-argument">
              <div class="useful-argument__logo useful-argument__logo_first"></div>
              <div class="useful-argument__text">Педиатры из ведущей сети СПб у вас дома</div>
            </div>
            <div class="useful-argument">
              <div class="useful-argument__logo useful-argument__logo_second"></div>
              <div class="useful-argument__text">Следуем принципам доказательной медицины</div>
            </div>
            <div class="useful-argument">
              <div class="useful-argument__logo useful-argument__logo_third"></div>
              <div class="useful-argument__text">Диагностика и экспресс-тесты на дому</div>
            </div>
            <div class="useful-argument">
              <div class="useful-argument__logo useful-argument__logo_fourth"></div>
              <div class="useful-argument__text">Маленький подарок для малыша</div>
            </div>
          </div>
        </div>
      </div>
      <!-- Блок "когда нужно вызвать врача" -->
      <span class="anchor" id="when-call-a-doctor"></span>
      <div class="when-call-a-doctor">
        <div class="when-call-a-doctor__background"></div>
        <div class="when-call-a-doctor__content">
          <div class="wrapper">
            <div class="base-content when-call-a-doctor_base-content">
              <span class="anchor" id="when-call-a-doctor_hack"></span>
              <h2 class="base-content__title">Когда нужно вызвать педиатра:</h2>
              <p class="patients-feedbacks__description" style="font-family: Lato;color: #425F86;margin-bottom: 30px;">Если у ребёнка:</p>
              <div class="base-content__list-container">
                <ul class="base-content__list-first-column">
                  <li class="base-content__list-item">Слабость, вялость, ломота</li>
                  <li class="base-content__list-item">Повышенная температура тела</li>
                  <li class="base-content__list-item">Кашель, насморк, боль в горле</li>
                  <li class="base-content__list-item">Одышка, хрипы, тяжёлое дыхание</li>
                  <li class="base-content__list-item">Тошнота, рвота или боль в животе</li>
                  <li class="base-content__list-item">Диарея, запор, вздутие</li>
                  <li class="base-content__list-item">Головная боль или головокружение</li>
                </ul>
                <ul class="base-content__list-second-column" v-if="isWhenCallADoctorSecondColumnShown">
                  <li class="base-content__list-item">Боль при мочеиспускании</li>
                  <li class="base-content__list-item">Покраснение глаз или конъюнктивит</li>
                  <li class="base-content__list-item">Кожные высыпания или покраснение</li>
                  <li class="base-content__list-item">Сухость во рту, сильная жажда</li>
                  <li class="base-content__list-item">Жалобы на боль в любом месте</li>
                  <li class="base-content__list-item">Ребенок не такой активный, как обычно</li>
                  <li class="base-content__list-item">Нужен осмотр для контроля лечения</li>
                </ul>
              </div>
              <div class="base-content__show-more-button" v-if="!isWhenCallADoctorSecondColumnShown" @click="isWhenCallADoctorSecondColumnShown = true">Показать больше</div>
            </div>
            <div class="when-call-a-doctor__button">
              <div class="call-doctor-button">
                <div class="call-doctor-link" @click="showPopup">
                  <div class="call-doctor-button__button">Вызвать врача</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Блок "что можно сделать на дому" -->
      <span class="anchor" id="what-to-do-at-home"></span>
      <div class="what-to-do-at-home">
        <div class="what-to-do-at-home__background" @click="openVideo">
          <div class="what-to-do-at-home__play"></div>
        </div>
        <div class="what-to-do-at-home__content" :class="{ 'what-to-do-at-home__content_short-content': !isWhatToDoAtHomeSecondColumnShown }">
          <div class="wrapper">
            <div class="base-content base-content_what-to-do">
              <h2 class="base-content__title">Что делает педиатр на выезде:</h2>
              <div class="base-content__list-container">
                <ul class="base-content__list-first-column">
                  <li class="base-content__list-item">Проводит полный осмотр ребёнка</li>
                  <li class="base-content__list-item">Даёт рекомендации и назначает лечение</li>

                  <li class="base-content__list-item">Делает экспресс-тесты по необходимости (ОРВИ, COVID, стрептококк и др.)</li>
                  <li class="base-content__list-item">Слушает лёгкие и сердце</li>
                  <li class="base-content__list-item">Выполняет пульсоксиметрию (степень насыщения крови кислородом)</li>
                </ul>
                <ul class="base-content__list-second-column" v-if="isWhatToDoAtHomeSecondColumnShown">
                  <li class="base-content__list-item">Осматривает горло, уши, слизистые</li>
                  <li class="base-content__list-item">Назначает анализы или берёт их сразу на дому</li>
                  <li class="base-content__list-item">Оформляет больничный или справку</li>
                  <li class="base-content__list-item">Может составить индивидуальный график вакцинации</li>
                </ul>
              </div>
              <div class="base-content__show-more-button" v-if="!isWhatToDoAtHomeSecondColumnShown" @click="isWhatToDoAtHomeSecondColumnShown = true">Показать больше</div>
            </div>
            <div class="wrapper" style="display: none">
              <div class="what-to-do-at-home__warning-container">
                <div class="what-to-do-at-home__warning">Мы не проводим на дому вакцинацию и пробы Манту.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Блок "Пациенты о нас" -->
      <span class="anchor" id="patients-feedbacks"></span>
      <div class="patients-feedbacks">
        <!-- блок со слайдером -->
        <div class="wrapper">
          <!-- текстовый контент -->
          <div class="patients-feedbacks__text-content">
            <h2 class="patients-feedbacks__title">Отзывы пациентов о нас</h2>
            <p class="patients-feedbacks__description">
              Мы с большим внимание относимся к каждому пациенту, поэтому если у вас есть замечания к нашей работе или вы хотели бы поблагодарить наших сотрудников, будем рады обратной связи
            </p>
          </div>
          <!-- слайдер -->
          <Swiper
            :slidesPerView="feedbacksCardsNumToShow"
            :spaceBetween="20"
            :slidesPerGroup="1"
            :loop="true"
            :loopFillGroupWithBlank="true"
            :pagination="false"
            :navigation="true"
            :modules="modules"
            class="mySwiper patients-feedbacks__slider"
          >
            <SwiperSlide v-for="(feedback, index) in feedbacksList" :key="index" @click="openPopupWithFeedback(index)">
              <!-- карточка отзыва -->
              <div class="feedback-card">
                <!-- контент карты отзыва -->
                <div class="feedback-card__card-content-contaniner">
                  <!-- контент текстовой карты -->
                  <div class="feedback-card__card-content-text" v-if="feedback.type === 'text'">
                    {{ feedback?.textToCard }}
                    <div class="feedback-card__for-text-blurring feedback-card__for-text-blurring_grad"></div>
                  </div>
                  <!-- контент видео карты -->
                  <div class="feedback-card__card-content-video" v-if="feedback.type === 'video'">
                    <img class="feedback-card__video-card-pic" :src="feedback?.cardPic?.url" :alt="alts[index]" />
                    <div class="feedback-card__video-play-icon"></div>
                  </div>
                  <!-- контент фото карты -->
                  <div class="feedback-card__card-content-photo" v-if="feedback.type === 'photo'">
                    <img class="feedback-card__photo-card-pic" :src="feedback?.photoToCard?.url" :alt="alts[index]" />
                  </div>
                </div>
                <!-- информация о клиенте + ссылка на попап -->
                <div class="feedback-card__client-info">
                  <!-- текстовая информация о клиенте -->
                  <div class="feedback-card__client-text-info">
                    <!-- имя клиента -->
                    <p class="feedback-card__client-name">{{ feedback?.nameOfClient }}</p>
                    <!-- описание клиента -->
                    <p class="feedback-card__client-description">{{ feedback?.descriptionOfClient }}</p>
                  </div>
                  <!-- ссылка на попап -->
                  <div class="feedback-card__link-to-popup-container">
                    <span class="feedback-card__link-to-popup">{{ this.defineTextToPopupLink(feedback?.type) }}</span>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
          <!-- опции управления -->
          <div class="patients-feedbacks__options-to-manipulate">
            <!-- кнопка "написать отзыв" -->
            <div class="patients-feedbacks__write-feedback-button-container">
              <div class="patients-feedbacks__write-feedback-button" @click="openPopupWithForm">Написать отзыв</div>
            </div>
            <!-- стрелки промотки слайдера -->
            <!-- кода нет, они находятся в слайдере, сюда будут помещены вёрсткой -->
          </div>
        </div>
      </div>
      <!-- Блок "команда выездной службы OnCall" -->
      <span class="anchor" id="oncall-service-team"></span>
      <div class="oncall-service-team">
        <div class="wrapper">
          <!-- заголовок блока "команда выездной службы OnCall" -->
          <h2 class="oncall-service-team__section-title">Команда выездной службы Lahta OnCall</h2>
          <!-- секция педиатров, слайдер -->
          <div class="oncall-service-team__doctors-section">
            <div class="doctors-section">
              <h3 class="doctors-section__title">Вызвать педиатра на дом</h3>
              <Swiper
                :slidesPerView="pediatriciansNumToShow"
                :spaceBetween="20"
                :slidesPerGroup="1"
                :loop="true"
                :loopFillGroupWithBlank="true"
                :pagination="false"
                :navigation="true"
                :modules="modules"
                class="mySwiper"
              >
                <SwiperSlide v-for="(doctorcard, index) in pediatriciansList" :key="index">
                  <!-- карточка врача -->
                  <div class="doctor-card">
                    <div class="doctor-card__photo-container">
                      <img class="doctor-card__photo" :src="doctorcard.photo.url" :alt="doctorcard.photo.alt" />
                    </div>
                    <div class="doctor-card__info-container">
                      <h4 class="doctor-card__name-title">{{ doctorcard.fullName }}</h4>
                      <p class="doctor-card__description">{{ doctorcard.description }}</p>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </div>
        </div>

        <!-- Странное поведение у слайдеров: при назначенных переменных - количествах карточек, пролистывание вправо идёт только до конца списка -->
      </div>
      <!-- Блок "карта покрытия" -->
      <span class="anchor" id="work-zone-map"></span>
      <div class="work-zone-map">
        <!-- фон -->
        <div class="work-zone-map__background"></div>
        <!-- контент -->
        <div class="wrapper">
          <div class="work-zone-map__content">
            <!-- контент над картой -->
            <div class="work-zone-map__top-content">
              <!-- заголовок -->
              <h2 class="work-zone-map__title">Стоимость вызова - 4 800 руб</h2>
              <!-- описание -->
              <p class="work-zone-map__description">Все районы Санкт-Петербурга, в которые выезжают наши врачи общей практики, детские врачи, медицинские сестры</p>
              <!-- кнопка "вызвать врача" (десктоп) -->
              <div class="work-zone-map__call-doctor-button">
                <div class="call-doctor-button">
                  <div class="call-doctor-link" @click="showPopup">
                    <div class="call-doctor-button__button">Вызвать врача</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Блок "Отвечаем на ваши вопросы" -->
      <span class="anchor" id="our-answers"></span>
      <div class="our-answers">
        <!-- контент -->
        <div class="wrapper">
          <!-- заголовок -->
          <h2 class="our-answers__title">Отвечаем на ваши вопросы</h2>
          <!-- ответы -->
          <div class="our-answers__content-container">
            <div class="answer" v-for="(answer, index) in ourAnswersList" :key="index" @click="answer.isAnswerShown = !answer.isAnswerShown">
              <div class="answer__icon" :class="{ answer__icon_minus: answer.isAnswerShown }"></div>
              <div class="answer__content">
                <p class="answer__question">{{ answer.question }}</p>
                <p class="answer__answer" v-show="answer.isAnswerShown">{{ answer.answer }}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- фон -->
        <div class="our-answers__background"></div>
      </div>

      <!-- Блок "Оставить заявку на вызов врача" -->
      <span class="anchor" id="submit-application"></span>
      <div class="submit-application">
        <!-- фон -->
        <div class="submit-application__background"></div>
        <!-- контент -->
        <div class="wrapper">
          <div class="submit-application__content">
            <!-- заголовок -->
            <h2 class="submit-application__title">Оставить заявку на вызов врача</h2>
            <!-- форма подачи заявки -->
            <div class="submit-application__form-container">
              <form class="application-form" action="#">
               
                <!-- адрес вызова -->
                <div class="application-form__form-component">
                  <h5 class="application-form__component-title">Адрес вызова</h5>
                  <div class="application-form__field-container">
                    <input class="application-form__field application-form__address-field" type="text" placeholder="" v-model="callRequest.addressField" />
                    <label class="application-form__field-label" :class="{ 'application-form__field-label_unempty-field': !!callRequest.addressField.length }">Улица и дом</label>
                  </div>
                </div>
                <!-- контактное лицо -->
                <div class="application-form__form-component">
                  <h5 class="application-form__component-title">Контактное лицо</h5>
                  <!-- поле имени -->
                  <div class="application-form__field-container">
                    <input class="application-form__field application-form__name-field" type="text" placeholder="" v-model="callRequest.nameField" />
                    <label class="application-form__field-label" :class="{ 'application-form__field-label_unempty-field': !!callRequest.nameField.length }">Имя</label>
                  </div>
                  <!-- поле телефона -->
                  <div class="application-form__field-container">
                    <input class="application-form__field application-form__telephone-field" type="text" placeholder="" v-model="callRequest.telephoneField" />
                    <label class="application-form__field-label" :class="{ 'application-form__field-label_unempty-field': !!callRequest.telephoneField.length }">Телефон</label>
                  </div>
                </div>
                <!-- галочка согласия на обработку данных -->
                <div class="application-form__form-component">
                  <label class="application-form__checkbox-content">
                    <div class="application-form__checkbox-icon" :class="{ 'application-form__checkbox-icon_agree': callRequest.isAgreeToDataWork }"></div>
                    <input type="checkbox" class="application-form__checkbox" v-model="callRequest.isAgreeToDataWork" />
                    <p class="application-form__text-content">
                      Я даю <a href="https://lahtaclinic.ru/agreement" target="_blank" class="feedback-send-form__personal-data-link">согласие</a> на обработку персональных данных, ознакомлен(а) с
                      <a class="feedback-send-form__personal-data-link" href="https://lahtaclinic.ru/licenses-and-documents/politika-obrabotki-i-zashity-personalnyh-dannyh/" target="_blank"
                        >Политикой конфиденциальности</a
                      >
                    </p>
                  </label>
                </div>
                <!-- кнопка отправки -->
                <div class="application-form__form-component">
                  <div class="application-form__submit-button-container">
                    <div class="application-form__submit-button" :class="{ 'application-form__submit-button_disabled': !callRequestFormValidation }" @click="sendDatatoCallRequest">Отправить</div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- Кнопка "вызвать врача" на мобильном" -->
      <div class="call-doctor-button" :class="{ none: isDropDownMenuShown }" v-if="!isFeedbackPopupShown">
        <div class="call-doctor-button__button"><a class="call-doctor-link" href="#" @click="openLink('https://oncall.lahtaclinic.ru/app')">Вызвать врача</a></div>
      </div>
    </main>
    <!-- Футер -->
    <footer class="page__footer">
      <div class="footer">
        <div class="wrapper">
          <div class="footer__contacts-and-links">
            <div class="footer__contacts">
              <p class="footer__email">
                Всегда рады обратной связи:<br />
                <a class="footer__email-value" href="mailto:info@lahtaclinic.ru">info@lahtaclinic.ru</a>
              </p>
              <p class="footer__address">ООО "Лахта Джуниор"<br />Санкт-Петербург, ул. Дибуновская, 50</p>
              <br />
              <p class="footer__address">ООО "Лахта Клиника"<br />Санкт-Петербург, ул. Дибуновская, 50</p>
            </div>
            <div class="footer__links">
              <a class="footer__link" target="_blank" href="https://lahtaclinic.ru/licenses-and-documents/">Документация</a>
              <a class="footer__link" target="_blank" href="https://lahtaclinic.ru/licenses-and-documents/politika-obrabotki-i-zashity-personalnyh-dannyh/"
                >Политика защиты и обработки персональных данных</a
              >
              <a class="footer__link" target="_blank" href="https://lahtaclinic.ru/wp-content/uploads/2022/09/Лицензия-Лахта-Джуниор.pdf">Лицензия № ЛО-78-01-009570</a>
              <a
                class="footer__link"
                target="_blank"
                href="https://lahtaclinic.ru/wp-content/uploads/2022/09/%D0%9B%D0%B8%D1%86%D0%B5%D0%BD%D0%B7%D0%B8%D1%8F-%D0%9B%D0%B0%D1%85%D1%82%D0%B0-%D0%BA%D0%BB%D0%B8%D0%BD%D0%B8%D0%BA%D0%B0.pdf"
                >Лицензия № Л041-01148-78/00345048</a
              >
              <a class="footer__link" target="_blank" href="https://lahtaclinic.ru/payment_methods/">Оплата банковской картой</a>
            </div>
          </div>
          <p class="footer__firm-description">
            © 2023 Cеть многопрофильных медицинских и диагностических центров Лахта Клиника<br />
            Информация и цены, представленные на сайте, являются справочными и не являются публичной офертой.
          </p>
        </div>
      </div>
    </footer>

    <!-- Попап куков встроенный -->
    <div
      class="inside-cookies-modal"
      :class="{
        'inside-cookies-modal_hidden': !cookiePopupOpened,
      }"
      @click="setCookieAccept"
    >
      <p class="inside-cookies-modal__text">
        Этот сайт собирает метаданные пользователя (cookie, данные об IP-адресах и местоположении). Это необходимо для функционирования сайта. Продолжая пользоваться сайтом, вы даете согласие на
        использование ваших cookie-файлов.
      </p>
      <div class="inside-cookies-modal__button">ок</div>
    </div>

    <!-- OnCallSuperBtn -->
    <OnCallSuperBtn @openCallme="showPopup" />
  </div>
</template>

<script>
// Компонент Vue-select
import VueSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { parseUTM, createUrl } from './../libs/UTM';

// Дополнительная форма, компонент
import ApplicationForm from './ApplicationForm.vue';

import ApplicationVideo from './ApplicationVideo.vue';

// OnCallSuperBtn компонент
import OnCallSuperBtn from './OnCallSuperBtn.vue';

// Свайпер
import { Swiper, SwiperSlide } from 'swiper/vue';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
// import "./style.css";

import { Pagination, Navigation } from 'swiper';
import { max } from 'date-fns';

export default {
  name: 'OnCallPage',
  components: {
    Swiper,
    SwiperSlide,
    ApplicationForm,
    ApplicationVideo,
    VueSelect,
    OnCallSuperBtn,
  },
  setup() {
    return {
      modules: [Pagination, Navigation],
    };
  },
  data() {
    return {
      // # Верхнее всплывающее окно "Перезвоните мне"
      isShownPopup: false,
      isShownPopupVideo: false,
      inactivityTimer: null,
      hasShownInactivityPopup: false,
      isInactivityPopup: false, // флаг для определения, что попап открыт через бездействие
      formContent: {
        formTitle: 'Перезвоните мне',
        formText: 'Оставьте заявку и наш менеджер свяжется с вами в ближайшее время',
        successTitle: 'Спасибо за обращение!',
        successText: 'Менеджер свяжется с вами в ближайшее время',
        sms: true,
      },
      inactivityFormContent: {
        formTitle: 'Поможем быстрее оформить вызов',
        formText: 'Оставьте ваш номер - наш координатор перезвонит и поможет вам с оформлением вызова на удобное время',
        successTitle: 'Спасибо за обращение!',
        successText: 'Менеджер свяжется с вами в ближайшее время',
        sms: true,
      },
      alts: [
        'вызов терапевта в приморском районе',
        'вызов терапевта в приморском районе',
        'вызов педиатра в приморском районе',
        'вызов врача на дом в любой район СПб',
        'вызов врача при высокой температуре',
        'забор анализов на дому',
      ],

      // # Хедер
      logoWay: { url: require('./@/../../assets/icons/oncall-page/logo.svg'), alt: 'логотип' },
      logoTextWay: {
        url: require('./@/../../assets/icons/oncall-page/lahta-on-call_icon.svg'),
        alt: 'текст логотипа',
      },

      // # Всплывающее меню
      // флаг для показа меню на мобильном
      isDropDownMenuShown: false,

      // # Блок "Когда нужно вызвать врача?"
      isWhenCallADoctorSecondColumnShown: false,

      // # Блок "Что можно сделать на дому?"
      isWhatToDoAtHomeSecondColumnShown: false,

      // # Блок "Команда выездной службы Lahta OnCall"
      // тестовые данные для отображения педиатров
      pediatriciansList: [
        {
          photo: {
            url: require('./@/../../assets/icons/oncall-page/oncall-team_test-photo.png'),
            alt: 'Педиатр',
          },
          fullName: 'Юлия Бессонова',
          description: 'Доказательный педиатр, выпускница СибГМУ, работала в детской реанимации, владеет вопросами в аллергологии, иммунологии, детском массаже',
        },
        {
          photo: {
            url: require('./@/../../assets/icons/oncall-page/oncall-team_test-photo.png'),
            alt: 'Педиатр',
          },
          fullName: 'Юлия Бессонова',
          description: 'Доказательный педиатр, выпускница СибГМУ, работала в детской реанимации, владеет вопросами в аллергологии, иммунологии, детском массаже',
        },
        {
          photo: {
            url: require('./@/../../assets/icons/oncall-page/oncall-team_test-photo.png'),
            alt: 'Педиатр',
          },
          fullName: 'Юлия Бессонова',
          description: 'Доказательный педиатр, выпускница СибГМУ, работала в детской реанимации, владеет вопросами в аллергологии, иммунологии, детском массаже',
        },
        {
          photo: {
            url: require('./@/../../assets/icons/oncall-page/oncall-team_test-photo.png'),
            alt: 'Педиатр',
          },
          fullName: 'Юлия Бессонова',
          description: 'Доказательный педиатр, выпускница СибГМУ, работала в детской реанимации, владеет вопросами в аллергологии, иммунологии, детском массаже',
        },
      ],
      // переменная для отображения количества педиатров в слайдере
      pediatriciansNumToShow: 4,
      // тестовые данные для отображения терапевтов
      therapistsList: [
        {
          photo: {
            url: require('./@/../../assets/icons/oncall-page/oncall-team_test-photo.png'),
            alt: 'Терапевт',
          },
          fullName: 'Юлия Бессонова',
          description: 'Доказательный педиатр, выпускница СибГМУ, работала в детской реанимации, владеет вопросами в аллергологии, иммунологии, детском массаже',
        },
        {
          photo: {
            url: require('./@/../../assets/icons/oncall-page/oncall-team_test-photo.png'),
            alt: 'Терапевт',
          },
          fullName: 'Юлия Бессонова',
          description: 'Доказательный педиатр, выпускница СибГМУ, работала в детской реанимации, владеет вопросами в аллергологии, иммунологии, детском массаже',
        },
        {
          photo: {
            url: require('./@/../../assets/icons/oncall-page/oncall-team_test-photo.png'),
            alt: 'Терапевт',
          },
          fullName: 'Юлия Бессонова',
          description: 'Доказательный педиатр, выпускница СибГМУ, работала в детской реанимации, владеет вопросами в аллергологии, иммунологии, детском массаже',
        },
        {
          photo: {
            url: require('./@/../../assets/icons/oncall-page/oncall-team_test-photo.png'),
            alt: 'Терапевт',
          },
          fullName: 'Юлия Бессонова',
          description: 'Доказательный педиатр, выпускница СибГМУ, работала в детской реанимации, владеет вопросами в аллергологии, иммунологии, детском массаже',
        },
      ],
      // переменная для отображения количества терапевтов в слайдере
      therapistsNumToShow: 4,

      // # Блок "Пациенты о нас"
      /*
                    типы объектов с фидбэками:
                    - video
                    - photo
                    - text
                */
      // список фидбэков
      feedbacksList: [
        // фото - карточка
        {
          type: 'photo',
          nameOfClient: 'Ирина',
          descriptionOfClient: 'клиентка Лахта клиники',
          avatarOfClient: {
            url: require('./@/../../assets/icons/oncall-page/client-avatar_Irina.png'),
            alt: 'аватар',
          },
          photoToCard: {
            url: require('./@/../../assets/icons/oncall-page/patients-feedbacks_photo-card_photo-1_card.png'),
            alt: 'отзыв',
          },
          photoToPopup: {
            url: require('./@/../../assets/icons/oncall-page/patients-feedbacks_photo-card_photo-1_popup.png'),
            alt: 'отзыв',
          },
        },
        // текст - карточка
        {
          type: 'text',
          nameOfClient: 'Ирина',
          descriptionOfClient: 'клиентка Лахта клиники',
          avatarOfClient: {
            url: require('./@/../../assets/icons/oncall-page/client-avatar_Irina.png'),
            alt: 'аватар',
          },
          textToCard:
            'Здравствуйте! Меня зовут Светлана. Мне 57 лет. Год назад — в декабре 2012 года, я сделала операцию на 2-м глазу по замене хрусталика. Операцию проводил доктор Самойленко Александр Игоревич. Хочу высказать свою огромную благодарность этому замечательному доктору и прекрасному человеку. Он — высокий профессионал.',
          textToPopup:
            'Здравствуйте! Меня зовут Светлана. Мне 57 лет. Год назад — в декабре 2012 года, я сделала операцию на 2-м глазу по замене хрусталика. Операцию проводил доктор Самойленко Александр Игоревич. Хочу высказать свою огромную благодарность этому замечательному доктору и прекрасному человеку. Он — высокий профессионал. Надеюсь, что Самойленко А. И. сможет подготовить себе достойных помощников и, в дальнейшем, таких же прекрасных врачей. Я благодарна судьбе, что попала в замечательные руки замечательного врача.',
        },
        // текст - карточка
        {
          type: 'text',
          nameOfClient: 'Ирина',
          descriptionOfClient: 'клиентка Лахта клиники',
          avatarOfClient: {
            url: require('./@/../../assets/icons/oncall-page/client-avatar_Irina.png'),
            alt: 'аватар',
          },
          textToCard:
            'Здравствуйте! Меня зовут Светлана. Мне 57 лет. Год назад — в декабре 2012 года, я сделала операцию на 2-м глазу по замене хрусталика. Операцию проводил доктор Самойленко Александр Игоревич. Хочу высказать свою огромную благодарность этому замечательному доктору и прекрасному человеку. Он — высокий профессионал.',
          textToPopup:
            'Здравствуйте! Меня зовут Светлана. Мне 57 лет. Год назад — в декабре 2012 года, я сделала операцию на 2-м глазу по замене хрусталика. Операцию проводил доктор Самойленко Александр Игоревич. Хочу высказать свою огромную благодарность этому замечательному доктору и прекрасному человеку. Он — высокий профессионал. Надеюсь, что Самойленко А. И. сможет подготовить себе достойных помощников и, в дальнейшем, таких же прекрасных врачей. Я благодарна судьбе, что попала в замечательные руки замечательного врача.',
        },
        // видео-карточка
        {
          type: 'video',
          nameOfClient: 'Ирина',
          descriptionOfClient: 'клиентка Лахта клиники',
          avatarOfClient: {
            url: require('./@/../../assets/icons/oncall-page/client-avatar_Irina.png'),
            alt: 'аватар',
          },
          videoLink: 'https://www.youtube.com/watch?v=DHIyb4ZEAhY',
          cardPic: {
            url: require('./@/../../assets/icons/oncall-page/patients-feedbacks_video-card_card-photo.png'),
            alt: 'видео-отзыв',
          },
        },
        // текст - карточка
        {
          type: 'text',
          nameOfClient: 'Ирина',
          descriptionOfClient: 'клиентка Лахта клиники',
          avatarOfClient: {
            url: require('./@/../../assets/icons/oncall-page/client-avatar_Irina.png'),
            alt: 'аватар',
          },
          textToCard: 'Здравствуйте! Меня зовут Светлана. Мне 57 лет. Год назад — в декабре 2012 года, я сделала операцию на 2-м глазу по замене хрусталика.',
          textToPopup:
            'Здравствуйте! Меня зовут Светлана. Мне 57 лет. Год назад — в декабре 2012 года, я сделала операцию на 2-м глазу по замене хрусталика. Операцию проводил доктор Самойленко Александр Игоревич. Хочу высказать свою огромную благодарность этому замечательному доктору и прекрасному человеку. Он — высокий профессионал. Надеюсь, что Самойленко А. И. сможет подготовить себе достойных помощников и, в дальнейшем, таких же прекрасных врачей. Я благодарна судьбе, что попала в замечательные руки замечательного врача.',
        },
        // видео-карточка
        {
          type: 'video',
          nameOfClient: 'Ирина',
          descriptionOfClient: 'клиентка Лахта клиники',
          avatarOfClient: {
            url: require('./@/../../assets/icons/oncall-page/client-avatar_Irina.png'),
            alt: 'аватар',
          },
          videoLink: 'https://www.youtube.com/shorts/S_jtom_f1eI',
          cardPic: {
            url: require('./@/../../assets/icons/oncall-page/patients-feedbacks_video-card_card-photo.png'),
            alt: 'видео-отзыв',
          },
        },
        // текст - карточка
        {
          type: 'text',
          nameOfClient: 'Ирина',
          descriptionOfClient: 'клиентка Лахта клиники',
          avatarOfClient: {
            url: require('./@/../../assets/icons/oncall-page/client-avatar_Irina.png'),
            alt: 'аватар',
          },
          textToCard:
            'Здравствуйте! Меня зовут Светлана. Мне 57 лет. Год назад — в декабре 2012 года, я сделала операцию на 2-м глазу по замене хрусталика. Операцию проводил доктор Самойленко Александр Игоревич. Хочу высказать свою огромную благодарность этому замечательному доктору и прекрасному человеку. Он — высокий профессионал.',
          textToPopup:
            'Здравствуйте! Меня зовут Светлана. Мне 57 лет. Год назад — в декабре 2012 года, я сделала операцию на 2-м глазу по замене хрусталика. Операцию проводил доктор Самойленко Александр Игоревич. Хочу высказать свою огромную благодарность этому замечательному доктору и прекрасному человеку. Он — высокий профессионал. Надеюсь, что Самойленко А. И. сможет подготовить себе достойных помощников и, в дальнейшем, таких же прекрасных врачей. Я благодарна судьбе, что попала в замечательные руки замечательного врача.',
        },
        // фото - карточка
        {
          type: 'photo',
          nameOfClient: 'Ирина',
          descriptionOfClient: 'клиентка Лахта клиники',
          avatarOfClient: {
            url: require('./@/../../assets/icons/oncall-page/client-avatar_Irina.png'),
            alt: 'аватар',
          },
          photoToCard: {
            url: require('./@/../../assets/icons/oncall-page/patients-feedbacks_photo-card_photo-2_card.png'),
            alt: 'отзыв',
          },
          photoToPopup: {
            url: require('./@/../../assets/icons/oncall-page/patients-feedbacks_photo-card_photo-2_popup.jpg'),
            alt: 'отзыв',
          },
        },
      ],
      // количество карточек отзывов для показа
      feedbacksCardsNumToShow: 5,
      // флаг, отвечающий за открытие/закрытие попапа для отзывов
      isFeedbackPopupShown: false,
      // данные для установки формы отправки отзыва в попапе
      feedbackSendFormData: {
        type: 'feedback-form',
      },
      // свойство, определяющее тип контента в попапе
      popupContentData: {
        type: 'feedback-form',
      },
      // свойства для данных в отправляемом отзыве
      feedbackDataToSend: {
        feedbackText: '',
        nameOfClient: '',
        telephoneOfClient: '',
        isAgreeToWorkWithData: true,
      },
      // флаг отправленного отзыва, состояние
      wasFeedbackSent: false,

      // # Блок "Отвечаем на ваши вопросы"
      // данные - вопросы и ответы
      ourAnswersList: [
        {
          question: 'Врач приедет в день вызова?',
          answer: 'Да, в большинстве случаев вызов врача на дом осуществляется день в день.',
          isAnswerShown: true,
        },
        {
          question: 'Можно ли вызвать определенного педиатра из выездной службы LahtaOnCall?',
          answer:
            'К сожалению, мы не можем гарантировать, что к вам приедет именно тот педиатр, о котором вы спрашиваете, так как врачи работают с привязкой к своей зоне, но мы постараемся удовлетворить ваш запрос, если будет такая возможность.',
          isAnswerShown: true,
        },
        {
          question: 'Можно ли взять анализы на дому?',
          answer:
            'Да, доктор может взять на дому анализы крови из пальца, но к сожалению это довольно ограниченный перечень анализов (клинический анализ крови, С-реактивный белок), если необходимо сдать большее количество показателей, необходимо вызывать медицинскую сестру. Врач так же может забрать анализы кала и мочи, взять ПЦР-тест и экспресс тест на стрептококк.',
          isAnswerShown: false,
        },
        {
          question: 'Может ли выездной педиатр открыть/закрыть больничный лист?',
          answer: 'Да, конечно',
          isAnswerShown: false,
        },
        {
          question: 'Может ли выездной педиатр выдать справку для сада/школы?',
          answer: 'Да, конечно',
          isAnswerShown: false,
        },
        {
          question: 'Сможет ли педиатр взвесить и измерить рост ребенка?',
          answer: 'К сожалению нет, у педиатра нет с собой весов и ростомера. Но вы можете указать это пожелание при оформлении вызова и мы постараемся его учесть.',
          isAnswerShown: false,
        },
        {
          question: 'Какие есть способы оплаты?',
          answer: 'Вы можете оплатить вызов врача онлайн на сайте, наличными педиатру, либо по ссылке, которую отправит наш администратор.',
          isAnswerShown: false,
        },
        {
          question: 'Можно ли вызвать врача по ДМС?',
          answer: 'Да, мы сотрудничаем с большим количеством страховых компаний. Вы можете оформить вызов через наш контактный центр и согласовать его со своей СК.',
          isAnswerShown: false,
        },
        {
          question: 'Можно ли пройти вакцинацию на дому?',
          answer: 'К сожалению нет, вакцинация на дому запрещена.',
          isAnswerShown: false,
        },
        {
          question: 'Можно ли получить консультацию врача выездной службы онлайн?',
          answer: 'Да, конечно. Запись на телемедицинскую консультацию можно оформить по телефону.',
          isAnswerShown: false,
        },
      ],

      // # Блок "Оставить заявку на вызов врача"
      // значения текстовых полей
      callRequest: {
        addressField: '',
        nameField: '',
        telephoneField: '',
        doctorSpecialization: { title: 'Терапевт', value: 'therapist' },
        isAgreeToDataWork: true,
      },
      callRequestWasSent: false,
      doctorSpecializations: [
        { title: 'Терапевт', value: 'therapist' },
        { title: 'Педиатр', value: 'pediatrician' },
      ],
      cookiePopupOpened: true,
    };
  },
  computed: {
    currentFormContent() {
      // Возвращаем специальный контент для попапа бездействия, иначе обычный
      return this.isInactivityPopup ? this.inactivityFormContent : this.formContent;
    },
    feedbackFormValidation() {
      let feedbackTextValidation = this.feedbackDataToSend.feedbackText.length > 0;
      let feedbackTelephoneValidation = this.feedbackDataToSend.telephoneOfClient.length > 0;
      let argreementWorkWithDataValidation = this.feedbackDataToSend.isAgreeToWorkWithData;

      return feedbackTextValidation && feedbackTelephoneValidation && argreementWorkWithDataValidation;
    },
    callRequestFormValidation() {
      let addressValidation = this.callRequest.addressField.length > 0;
      let telephoneValidation = this.callRequest.telephoneField.length > 0;
      let argreementWorkWithDataValidation = this.callRequest.isAgreeToDataWork;

      return addressValidation && telephoneValidation && argreementWorkWithDataValidation;
    },
  },
  methods: {
    openVideo() {
      if (this.isDropDownMenuShown) {
        this.hideDropDownMenu();
      }

      console.log('123');

      this.freezeScroll();
      this.isShownPopupVideo = true;
    },
    disableDefaultCookiePopup() {
      let defaultPopup = document.querySelector('#cookies-modal');
      if (defaultPopup === null) return;

      defaultPopup.style.display = 'none';
    },
    defineHasCookie() {
      let cookieMarker = 'cookies=true';
      let hasCookie = document.cookie.includes(cookieMarker);
      this.cookiePopupOpened = !hasCookie;
    },
    setCookieAccept() {
      console.log('setCookieAccept');

      function setCookie(name, value, days) {
        let expires = '';
        if (days) {
          let date = new Date();
          date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
          expires = '; expires=' + date.toUTCString();
        }
        document.cookie = name + '=' + (value || '') + expires + '; path=/';
      }

      setCookie('cookies', 'true', 400);
      this.cookiePopupOpened = false;
    },
    openLink(link) {
      link = createUrl(link);

      window.open(link, '_blank');
    },
    // методы верхнего попапа "Перезвоните мне"
    setFormContent(event, target) {
      if (event && event.target && event.target.dataset) {
        let values = Object.assign({}, event.target.dataset);
        for (let prop in values) {
          this.formContent[prop] = values[prop];
        }
      }
      if (target) {
        this.formContent['formTarget'] = target;
      }
    },
    freezeScroll() {
      document.body.style.overflow = 'hidden';
    },
    unfreezeScroll() {
      document.body.style.overflow = '';
    },
    // метод открытия верхнего попапа "Перезвоните мне"
    showPopup(event) {
      if (this.isDropDownMenuShown) {
        this.hideDropDownMenu();
      }

      // Останавливаем таймер бездействия, если попап открывается вручную
      if (this.inactivityTimer) {
        clearTimeout(this.inactivityTimer);
        this.inactivityTimer = null;
      }
      this.hasShownInactivityPopup = true;
      this.isInactivityPopup = false; // попап открыт вручную, не через бездействие

      this.setFormContent(event || null);
      this.freezeScroll();
      this.isShownPopup = true;
    },
    showPopupBreastfeed(event) {
      // console.log(event)
      if (this.isDropDownMenuShown) {
        this.hideDropDownMenu();
      }

      // Останавливаем таймер бездействия, если попап открывается вручную
      if (this.inactivityTimer) {
        clearTimeout(this.inactivityTimer);
        this.inactivityTimer = null;
      }
      this.hasShownInactivityPopup = true;
      this.isInactivityPopup = false; // попап открыт вручную, не через бездействие

      this.setFormContent(event, 'Заявка на вызов специалиста по грудному вскармливанию');
      this.freezeScroll();
      this.isShownPopup = true;
    },
    showPopupSister(event) {
      // console.log(event)
      if (this.isDropDownMenuShown) {
        this.hideDropDownMenu();
      }

      // Останавливаем таймер бездействия, если попап открывается вручную
      if (this.inactivityTimer) {
        clearTimeout(this.inactivityTimer);
        this.inactivityTimer = null;
      }
      this.hasShownInactivityPopup = true;
      this.isInactivityPopup = false; // попап открыт вручную, не через бездействие

      this.setFormContent(event, 'Заявка на выезд медсестры');
      this.freezeScroll();
      this.isShownPopup = true;
    },
    hidePopup() {
      this.unfreezeScroll();
      this.isShownPopup = false;
      this.isShownPopupVideo = false;
      this.isInactivityPopup = false; // сбрасываем флаг при закрытии
    },
    // методы для попапа бездействия
    initInactivityTimer() {
      // Показываем попап только один раз
      if (this.hasShownInactivityPopup) {
        return;
      }

      // Останавливаем активный таймер перед созданием нового
      if (this.inactivityTimer) {
        clearTimeout(this.inactivityTimer);
      }

      // Устанавливаем таймер на 30 секунд
      this.inactivityTimer = setTimeout(() => {
        this.showInactivityPopup();
      }, 30000);
    },
    showInactivityPopup() {
      // Показываем попап только если он еще не был показан и не открыт сейчас
      if (this.hasShownInactivityPopup || this.isShownPopup) {
        return;
      }

      this.hasShownInactivityPopup = true;
      this.isInactivityPopup = true; // помечаем, что попап открыт через бездействие
      // Устанавливаем formTarget для попапа бездействия
      this.inactivityFormContent.formTarget = 'Перезвоните мне - попап бездействия';
      this.freezeScroll();
      this.isShownPopup = true;
    },
    // методы выпадающего меню
    setBodyNoScrollInMobile() {
      let body = document.body;
      let currentWidth = window.innerWidth;

      if (!this.isDropDownMenuShown || currentWidth > 700) {
        return;
      }

      body.style.overflow = 'hidden';
    },
    setBodyNoScroll() {
      let body = document.body;
      body.style.overflow = 'hidden';
    },
    showDropDownMenu() {
      this.isDropDownMenuShown = true;
      this.setBodyNoScrollInMobile();
    },
    setBodyScroll() {
      let body = document.body;
      body.style.overflow = '';
    },
    hideDropDownMenu() {
      this.isDropDownMenuShown = false;
      this.setBodyScroll();
    },
    // скрыть или показать вторую колонку контента в блоках "Когда нужно вызвать врача?" и "Что можно сделать на дому?"
    setShowMoreButton() {
      let currentScreenWidth = window.innerWidth;
      if (currentScreenWidth < 1200) {
        this.isWhenCallADoctorSecondColumnShown = false;
        this.isWhatToDoAtHomeSecondColumnShown = false;
      } else {
        this.isWhenCallADoctorSecondColumnShown = true;
        this.isWhatToDoAtHomeSecondColumnShown = true;
      }
    },
    setSlidesNumToShow() {
      let slidesNumToShow = 1;
      let currentScreenWidth = window.innerWidth;
      let includes = (num, min, max) => num >= min && num < max;

      if (includes(currentScreenWidth, 670, 1000)) {
        slidesNumToShow = 2;
      } else if (includes(currentScreenWidth, 1000, 1980)) {
        slidesNumToShow = 3;
      } else if (currentScreenWidth >= 1980) {
        slidesNumToShow = 4;
      }

      this.pediatriciansNumToShow = slidesNumToShow;
      this.therapistsNumToShow = slidesNumToShow;
    },
    setNodeHeight(backgroundNode, inputData, contentNode) {
      let isMobile = window.innerWidth < inputData.desktopBreakPoint;

      let referenceWidth = isMobile ? inputData.referenceWidth.mobile : inputData.referenceWidth.desktop;
      let referenceHeight = isMobile ? inputData.referenceHeight.mobile : inputData.referenceHeight.desktop;

      let widthCoefficient = inputData.widthCoefficient();
      let currentHeight = (window.innerWidth * widthCoefficient * referenceHeight) / referenceWidth;

      if ((isMobile && currentHeight <= inputData.maxHeight.mobile) || (!isMobile && currentHeight <= inputData.maxHeight.desktop)) {
        backgroundNode.style.height = `${currentHeight}px`;

        if (!contentNode) return;
        contentNode.style.height = ``;
        let currentContentHeight = parseFloat(getComputedStyle(contentNode)['height']);
        contentNode.style.height = currentHeight > currentContentHeight ? `${currentHeight + 50}px` : '';
      }
    },
    // методы работы с отзывами
    defineTextToPopupLink(type) {
      let textToLink = 'Читать полностью';
      switch (type) {
        case 'video':
          textToLink = 'Смотреть видео';
          break;
        case 'photo':
          textToLink = 'Открыть фото';
          break;
      }

      return textToLink;
    },
    setFeedbacksNum() {
      let currenScreenWidth = window.innerWidth;
      let feedbacksNum = 1;
      let includes = (num, min, max) => num >= min && num < max;

      if (includes(currenScreenWidth, 0, 649)) {
        feedbacksNum = 1;
      } else if (includes(currenScreenWidth, 650, 938)) {
        feedbacksNum = 2;
      } else if (includes(currenScreenWidth, 938, 1258)) {
        feedbacksNum = 3;
      } else if (includes(currenScreenWidth, 1258, 1740)) {
        feedbacksNum = 4;
      } else if (includes(currenScreenWidth, 1740, 2105)) {
        feedbacksNum = 5;
      } else if (includes(currenScreenWidth, 2105, 10000)) {
        feedbacksNum = 6;
      }

      this.feedbacksCardsNumToShow = feedbacksNum;
    },
    setCardDataToPopup(index) {
      let cardObjectData = this.feedbacksList[index];
      this.popupContentData = cardObjectData;
    },
    setFeedbackFormdataToPopup() {
      this.popupContentData = this.feedbackSendFormData;
    },
    openPopupWithFeedback(index) {
      this.setCardDataToPopup(index);
      this.setBodyNoScroll();
      this.isFeedbackPopupShown = true;
    },
    openPopupWithForm() {
      this.setFeedbackFormdataToPopup();
      this.setBodyNoScroll();
      this.isFeedbackPopupShown = true;
    },
    clearFeedbackPopup() {
      this.feedbackDataToSend.feedbackText = '';
      this.feedbackDataToSend.nameOfClient = '';
      this.feedbackDataToSend.telephoneOfClient = '';
      this.feedbackDataToSend.isAgreeToWorkWithData = false;

      this.wasFeedbackSent = false;

      let successWrapper = document.querySelector('.feedback-send-form__success-message-wrapper');
      successWrapper.style.height = '';
    },
    clearCallRequestForm() {
      this.callRequest.addressField = '';
      this.callRequest.nameField = '';
      this.callRequest.telephoneField = '';
      this.callRequest.doctorSpecialization = { title: 'Терапевт', value: 'therapist' };
      this.callRequest.isAgreeToDataWork = false;
    },
    closePopup() {
      this.isFeedbackPopupShown = false;
      this.setBodyScroll();

      if (this.popupContentData.type === 'feedback-form') {
        this.clearFeedbackPopup();
      }
      if (this.callRequestWasSent) {
        this.callRequestWasSent = false;
      }

      this.popupContentData = this.feedbackSendFormData;
    },
    closePopupByClickAround(event) {
      if (!event.target.classList.contains('screen-veil')) return;
      this.closePopup();
    },
    sendData(data) {
      let url = 'https://lahtaclinic.ru/app/app.php';

      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: data,
      }).then((res) => res.json());
    },
    createPropsString(obj) {
      let props = Object.assign({ method: 'create_notification', type: 'universal', time: new Date() }, obj);

      return Object.keys(props)
        .reduce((a, k) => {
          a.push(k + '=' + encodeURIComponent(props[k]));
          return a;
        }, [])
        .join('&');
    },
    sendFeedback() {
      // валидация
      if (!this.feedbackFormValidation) return;

      // отправка
      let dataToSend = this.createPropsString({
        name: this.feedbackDataToSend.nameOfClient,
        phone: this.feedbackDataToSend.telephoneOfClient,
        comment: this.feedbackDataToSend.feedbackText,
        target: 'форма отправки отзыва',
        page: window.location.href,
        title: document.title,
      });
      this.sendData(dataToSend);

      // изменения на фронтенде
      this.wasFeedbackSent = true;
      let formWrapper = document.querySelector('.feedback-send-form__form-wrapper');
      let formWrapperHeight = getComputedStyle(formWrapper).height;
      let successWrapper = document.querySelector('.feedback-send-form__success-message-wrapper');
      successWrapper.style.height = formWrapperHeight;
    },
    sendDatatoCallRequest() {
      // валидация
      if (!this.callRequestFormValidation) return;

      let dataToSend = this.createPropsString({
        name: this.callRequest.nameField,
        phone: this.callRequest.telephoneField,
        comment: this.callRequest.addressField,
        specialization: this.callRequest.doctorSpecialization.value,
        target: 'форма запроса звонка',
        page: window.location.href,
        title: document.title,
        // "isBreastfeed": this.fo
      });
      this.sendData(dataToSend);

      // фронтенд отправки заявки
      this.callRequestWasSent = true;
      this.wasFeedbackSent = true;
      this.clearCallRequestForm();
      this.openPopupWithForm();

      //seo
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'formMainGTM',
      });
    },
  },
  mounted() {
    console.log(window.innerWidth);
    if (window.innerWidth > 420) {
      const scrollDemo = document.querySelector('#central-functions');
      // scrollDemo.style.display = "none";

      window.addEventListener(
        'scroll',
        (event) => {
          if (window.scrollY > 90) {
            scrollDemo.classList.remove('none');
          } else {
            scrollDemo.classList.add('none');
          }
        },
        { passive: true }
      );
    }

    // настройка динамического изменения фона приветствия
    let greetingBackground = document.querySelector('.greeting-block__background');
    let greetingBackgroundInputData = {
      desktopBreakPoint: 1200,
      referenceWidth: { mobile: 320, desktop: 1200 },
      referenceHeight: { mobile: 245, desktop: 815 },
      maxHeight: {
        mobile: 414,
        desktop: 10000,
      },
      widthCoefficient() {
        return 1;
      },
    };
    let setGreetingBackgroundHeight = this.setNodeHeight.bind(this, greetingBackground, greetingBackgroundInputData, null);
    setGreetingBackgroundHeight();
    window.addEventListener('resize', setGreetingBackgroundHeight);

    // настройка динамического изменения фона "Что можно сделать на дому"
    let whatToDoAtHomeBackground = document.querySelector('.what-to-do-at-home__background');
    let whatToDoAtHomeContent = document.querySelector('.what-to-do-at-home__content');
    let whatToDoAtHomeBackgroundInputData = {
      // desktopBreakPoint: 540,
      desktopBreakPoint: 900,
      referenceWidth: { mobile: 320, desktop: 297 },
      referenceHeight: { mobile: 300, desktop: 320 },
      maxHeight: {
        mobile: 10000,
        get desktop() {
          let maxHeight = 10000;
          if (window.innerWidth >= 1600) maxHeight = 10000;

          return maxHeight;
        },
      },
      widthCoefficient() {
        let coefficient = 1;
        // if (window.innerWidth >= 540) {
        if (window.innerWidth >= 900) {
          coefficient = 0.55;
        } else if (window.innerWidth >= 1800) {
          coefficient = 0.7;
        }

        return coefficient;
      },
    };
    let setWhatToDoAtHomeBackgroundHeight = this.setNodeHeight.bind(this, whatToDoAtHomeBackground, whatToDoAtHomeBackgroundInputData, null);
    setWhatToDoAtHomeBackgroundHeight();
    window.addEventListener('resize', setWhatToDoAtHomeBackgroundHeight);

    // настройка динамического изменения фона "Что можно сделать на дому"
    // let breastfeedBackground = document.querySelector('.breastfeed__background');
    // let breastfeedHomeContent = document.querySelector('.breastfeed__content');
    // let breastfeedBackgroundInputData = {
    //   // desktopBreakPoint: 540,
    //   desktopBreakPoint: 900,
    //   referenceWidth: { mobile: 320, desktop: 297 },
    //   referenceHeight: { mobile: 300, desktop: 320 },
    //   maxHeight: {
    //     mobile: 10000,
    //     get desktop() {
    //       let maxHeight = 10000;
    //       if (window.innerWidth >= 1600) maxHeight = 10000;

    //       return maxHeight;
    //     },
    //   },
    //   widthCoefficient() {
    //     let coefficient = 1;
    //     // if (window.innerWidth >= 540) {
    //     if (window.innerWidth >= 900) {
    //       coefficient = 0.55;
    //     } else if (window.innerWidth >= 1800) {
    //       coefficient = 0.7;
    //     }

    //     return coefficient;
    //   },
    // };
    // let setBreastfeedBackgroundHeight = this.setNodeHeight.bind(this, breastfeedBackground, breastfeedBackgroundInputData, null);
    // setBreastfeedBackgroundHeight();
    // window.addEventListener('resize', setBreastfeedBackgroundHeight);

    // настройка динамического изменения фона "Карта покрытия"
    let workZoneMapBackground = document.querySelector('.work-zone-map__background');
    let workZoneMapContent = document.querySelector('.work-zone-map__content');
    let workZoneMapBackgroundInputData = {
      desktopBreakPoint: 1200,
      referenceWidth: { mobile: 320, desktop: 1200 },
      referenceHeight: { mobile: 540, desktop: 555 },
      maxHeight: { mobile: 10000, desktop: 10000 },
      widthCoefficient() {
        return 1;
      },
    };
    let setWorkZoneMapBackgroundHeight = this.setNodeHeight.bind(this, workZoneMapBackground, workZoneMapBackgroundInputData, workZoneMapContent);
    setWorkZoneMapBackgroundHeight();
    window.addEventListener('resize', setWorkZoneMapBackgroundHeight);

    // настройка динамического изменения фона "Оставить заявку на вызов врача"
    let submitApplicationBackground = document.querySelector('.submit-application__background');
    let submitApplicationContent = document.querySelector('.submit-application__content');
    let submitApplicationBackgroundInputData = {
      desktopBreakPoint: 800,
      referenceWidth: { mobile: 320, desktop: 320 },
      referenceHeight: { mobile: 450, desktop: 500 },
      maxHeight: { mobile: 10000, desktop: 10000 },
      widthCoefficient() {
        return 1;
      },
    };
    let setSubmitApplicationBackgroundHeight = this.setNodeHeight.bind(this, submitApplicationBackground, submitApplicationBackgroundInputData, submitApplicationContent);
    setSubmitApplicationBackgroundHeight();
    window.addEventListener('resize', setSubmitApplicationBackgroundHeight);

    // настройка количества показанных врачей в команде выездной службы на экране
    this.setSlidesNumToShow();
    window.addEventListener('resize', this.setSlidesNumToShow);

    // настроить прокрутку у body при открытом меню на мобильном
    window.addEventListener('resize', (event) => {
      if (window.innerWidth <= 700) {
        this.setBodyNoScrollInMobile();
      } else {
        this.setBodyScroll();
      }
    });

    // настроить количество слайдов отзывов на странице
    this.setFeedbacksNum();
    window.addEventListener('resize', this.setFeedbacksNum);

    if (window.pediatriciansList) {
      this.pediatriciansList = JSON.parse(JSON.stringify(window.pediatriciansList));
    }

    if (window.therapistsList) {
      this.therapistsList = JSON.parse(JSON.stringify(window.therapistsList));
    }

    if (window.content) {
      this.feedbacksList = JSON.parse(JSON.stringify(window.content));
    }

    // настроить скрытие или показ вторую колонку контента в блоках "Когда нужно вызвать врача?" и "Что можно сделать на дому?"
    this.setShowMoreButton();
    // window.addEventListener("resize", this.setShowMoreButton);

    // работа с куками
    // нужен ли попап
    this.defineHasCookie();
    // закрыть старый попап
    setTimeout(() => {
      this.disableDefaultCookiePopup();
    }, 500);

    // Логика показа попапа через 30 секунд
    this.initInactivityTimer();
  },
  created() {
    parseUTM(window.location.href);
  },
  beforeUnmount() {
    // Очищаем таймер бездействия
    if (this.inactivityTimer) {
      clearTimeout(this.inactivityTimer);
    }
  },
};
</script>

<style lang="scss">
html {
  scroll-behavior: smooth;
}

.anchor {
  display: block;
  height: 100px;
  margin-top: -100px;
  visibility: hidden;
}

@media screen and (max-width: 992px) {
  .anchor {
    display: block;
    height: 60px !important;
    margin-top: -60px !important;
    visibility: hidden;
  }
}

.lahta-oncall .call-me-page-form__close_button {
  top: 0px !important;
  right: 0px !important;
}

._header__dropdown {
  display: flex;
  align-self: stretch;
  position: relative;
  border-right: 1px solid rgba(188, 196, 207, 0.3);
}

._header__dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 250px;
  background: #fff;
  z-index: 2;
  border-radius: 0 0 8px 8px;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s;
}

._header__dropdown:hover ._header__dropdown-menu,
._header__dropdown-menu--open {
  opacity: 1;
  visibility: visible;
}

._header__dropdown-toggler-icon {
  transition: transform 0.3s;
  color: #bcc4cf;
}

._header__dropdown:hover ._header__dropdown-toggler-icon,
._header__dropdown-toggler--open ._header__dropdown-toggler-icon {
  transform: rotate(180deg);
}

._header__dropdown-toggler {
  display: flex;
  align-items: center;
  align-self: stretch;
  gap: 0 10px;
  text-align: left;
  border: 0;
  padding: 10px 24px 10px 24px;
  margin: 0;
  background-color: transparent;
  cursor: pointer;
  font-family: "Lato";
  font-weight: 700;
  color: #425F86;
  text-transform: uppercase;
}
._header__dropdown-toggler .other-site-link__place-sign-pic {
  margin: 0 !important;
}
._header__dropdown .other-site-link {
  border-right: 0 !important;
}
._header__dropdown .header__other-site-link:hover .other-site-link__title {
  color: #288fe3;
}

.other-site-link__place-sign-pic {
  flex-shrink: 0;
}

@media (max-width: 1199px) {
  ._header__dropdown {
    display: none;
  }
}
</style>
